import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const { user, setUser } = useAuth();
    const [status, setStatus] = useState("polling");
    const [credits, setCredits] = useState(null);
    const sid = params.get("session_id");

    useEffect(() => {
        if (!sid) return;
        let tries = 0;
        const iv = setInterval(async () => {
            tries++;
            try {
                const r = await axios.get(`${API}/payments/status/${sid}`);
                if (r.data.payment_status === "paid") {
                    setStatus("paid");
                    setCredits(r.data.credits);
                    clearInterval(iv);
                    // Refresh user
                    const me = await axios.get(`${API}/auth/me`);
                    setUser(me.data);
                } else if (["expired", "failed"].includes(r.data.payment_status)) {
                    setStatus("failed");
                    clearInterval(iv);
                }
            } catch {}
            if (tries > 30) { setStatus("timeout"); clearInterval(iv); }
        }, 2000);
        return () => clearInterval(iv);
    }, [sid, setUser]);

    return (
        <div className="min-h-screen bg-[#FAF9F6]" data-testid="payment-success">
            <Navbar />
            <main className="pt-32 pb-24">
                <div className="max-w-lg mx-auto px-6 text-center">
                    <div className="flex items-center gap-3 mb-6 justify-center">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">Paiement</span>
                    </div>
                    {status === "polling" && (
                        <>
                            <div className="w-10 h-10 border-2 border-[#B89C6A] border-t-transparent rounded-full animate-spin mx-auto" />
                            <h1 className="font-serif-lux text-3xl mt-6">Confirmation en cours…</h1>
                            <p className="mt-4 text-[13px] text-[#1C1E1D]/60">Un instant, nous vérifions votre paiement.</p>
                        </>
                    )}
                    {status === "paid" && (
                        <>
                            <h1 className="font-serif-lux text-4xl">Merci ! ✨</h1>
                            <p className="mt-4 text-[15px]">
                                <b>{credits}</b> rendu(s) IA ajouté(s) à votre compte.<br/>
                                Solde total : <b className="text-[#B89C6A]">{user?.render_credits ?? 0}</b>
                            </p>
                            <Link to="/cmrenov-ai" className="btn-champagne mt-8 inline-flex">
                                Générer un rendu →
                            </Link>
                        </>
                    )}
                    {["failed", "timeout"].includes(status) && (
                        <>
                            <h1 className="font-serif-lux text-3xl text-[#8b0000]">Paiement non abouti</h1>
                            <p className="mt-4 text-[13px]">Aucun montant n'a été débité. Réessayez ou contactez-nous.</p>
                            <button onClick={() => nav("/cmrenov-ai")} className="btn-outline mt-6">Retour</button>
                        </>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}
